export * from './domain';
export * from './testkit';
export * from './builders';
export var createEmailDashboardApi = function (baseUrl, http) {
    var url = baseUrl + "/dashboard/ticketing";
    return {
        getTableData: function (dashboardDto) { return http.post("" + url, dashboardDto); },
        getDashboardOverview: function (emailDashboardOverviewDto) { return http.post(url + "/overview", emailDashboardOverviewDto); },
    };
};
//# sourceMappingURL=index.js.map